import React, { Component } from 'react';
//import Config from './Config';
import { Scrollbars } from 'react-custom-scrollbars';
import './css/Menu.css';
import FX from './functions/functions';
class Menu extends Component {
  navigate = (btn) => {
    FX.navigate.bind(this.props.root,btn.panel, undefined ,btn.path)();
    this.props.root.setState({menu_show: false});
  }
  render() {
    var button_data = [
      {path:'/',panel:'dashboard',title:'Home'},
    ];
    var isAdmin = !!parseInt(this.props.root.state.user.admin_level, 10);
    console.log((this.props.root.state.user.admin));
    console.log(parseInt(this.props.root.state.user.admin_level, 10));
    console.log(isAdmin);
    var hasCustomer = !!parseInt(this.props.root.state.customer_id, 10);
    if(isAdmin){
      button_data.push(
        //{path:'/admin',panel:'admin',title:'Admin Actions'},
        {path:'/clients',panel:'customers',title:'Clients'},
        {path:'/order_lookup',panel:'order_lookup',title:'Order Lookup'},
        {path:'/packing_station',panel:'packing_station',title:'Packing Station'}
      );
    }
    if(hasCustomer){
      button_data.push(
        {path:'/products',panel:'products',title:'Products'},
        {path:'/orders',panel:'orders',title:'Orders'}
      );
    }
    if(hasCustomer && isAdmin){
      button_data.push(
        {path:'/dispatches',panel:'dispatches',title:'Dispatches'}
     )
    }
    if(hasCustomer){
      button_data.push(
        {path:'/deliveries',panel:'deliveries',title:'Deliveries'}//,
        //{path:'/returns',panel:'returns',title:'Returns'}
     )
    }
    if(isAdmin){
      button_data.push(
        {path:'/stock_take',panel:'stock_take',title:'Stock Take'},
        {path:'/invoicing',panel:'invoicing',title:'Invoicing'}
      );
    }
    button_data.push(
      {path:'/reports',panel:'reports',title:'Reports'},
      //{path:'/account',panel:'account',title:'Account'},
      //{path:'/settings',panel:'settings',title:'Settings'},
      //{path:'/logout',panel:'logout',title:<i className="fa fa-sign-out" aria-hidden="true" />,className:'logout'},
    );









    var buttons = button_data.map((btn, i) => {
       var className="button";
       if (btn.panel  ===  this.props.root.state.panel){
         className +=" active"
       }
       if (btn.className){
         className +=" " + btn.className
       }
       return <span key={i} className={className} onClick={() => {this.navigate(btn); if( this.props.root.current && typeof this.props.root.current.refresh === 'function'){this.props.root.current.refresh()}}}><span className="carrier">{btn.title}</span></span>
    });

    var show = '';
    if (this.props.root.state.menu_show){
      show = 'show';
    }

    return (
      <div className={'Menu '+ show} id="Menu">
        <a style={{textIndent:9999}} onClick={(e)=>{e.preventDefault()}} href="/" className="logo">Home</a>
        <div className="MenuItems">
          <Scrollbars style={{ width: '100%' }}>
            {buttons}
            <br/><br/>
            <div style={{width: '100%', alignContent: 'center', display: 'flex', justifyContent: 'center', marginTop: '10px'}}>
                <span style={{width: '100%', color: 'white', fontSize: '10px', textAlign: 'center'}}>v: {require('../package.json').version}</span>
            </div>
          </Scrollbars>

        </div>
        <div  className="foot_icons">
          <div className="settings_btn" onClick={this.navigate.bind(this, {panel : 'settings'})}>
            <i className="fa fa-cog" aria-hidden="true"></i>
          </div>
          <div className="logout" onClick={(e)=> {if(window.confirm('Are you sure you wish to log out?')){this.navigate({panel : 'logout'})}}}>
            <i className="fa fa-sign-out" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/Menu.js